import Action from 'redux/helpers/createAction'
const name = 'keywordDiscovery'

export const getDomainKeywordDiscovery = Action(
  name + '/GET_DOMAIN_KEYWORD_DISCOVERY_DATA',
  (domainId, filters) => ({
    domainId,
    filters
  })
)

export const getDomainKeywordDiscoverySuccess = Action(
  name + '/GET_DOMAIN_KEYWORD_DISCOVERY_DATA_SUCCESS',
  (discovery, id) => ({
    discovery,
    id
  })
)

export const getDomainKeywordDiscoveryFailure = Action(
  name + '/GET_DOMAIN_KEYWORD_DISCOVERY_DATA_FAILURE',
  error => ({
    error
  })
)

export const exportDomainKeywordDiscoveryExcel = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_DISCOVERY_DATA_EXCEL',
  domainId => ({
    domainId
  })
)

export const exportDomainKeywordDiscoveryCSV = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_DISCOVERY_DATA_CSV',
  domainId => ({
    domainId
  })
)
